import { render, staticRenderFns } from "./BusRouteMap.vue?vue&type=template&id=97540b96&scoped=true"
import script from "./BusRouteMap.vue?vue&type=script&lang=js"
export * from "./BusRouteMap.vue?vue&type=script&lang=js"
import style0 from "./BusRouteMap.vue?vue&type=style&index=0&id=97540b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97540b96",
  null
  
)

export default component.exports